import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBreadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeLabels = {
    '/dashboard-principal': 'Dashboard',
    '/caja': 'Caja',
    '/order-management': 'Órdenes',
    '/quotes-management': 'Cotizaciones',
    '/inventario': 'Inventario',
    '/clientes': 'Clientes',
    '/reportes': 'Reportes',
    '/productos': 'Productos',
    '/usuarios': 'Usuarios'
  };

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
  
  const breadcrumbItems = pathSegments?.map((segment, index) => {
    const path = `/${pathSegments?.slice(0, index + 1)?.join('/')}`;
    return {
      label: routeLabels?.[path] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1),
      path: path,
      isLast: index === pathSegments?.length - 1
    };
  });

  if (breadcrumbItems?.length === 0) {
    return null;
  }

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleKeyDown = (e, path) => {
    if (e?.key === 'Enter' || e?.key === ' ') {
      e?.preventDefault();
      handleNavigation(path);
    }
  };

  return (
    <nav aria-label="Breadcrumb" className="breadcrumb py-4">
      <ol className="flex items-center space-x-2">
        <li>
          <button
            onClick={() => handleNavigation('/dashboard-principal')}
            onKeyDown={(e) => handleKeyDown(e, '/dashboard-principal')}
            className="breadcrumb-item flex items-center focus-ring rounded"
            aria-label="Ir al inicio"
          >
            <Icon name="Home" size={16} />
          </button>
        </li>
        
        {breadcrumbItems?.map((item, index) => (
          <React.Fragment key={item?.path}>
            <li className="breadcrumb-separator" aria-hidden="true">
              <Icon name="ChevronRight" size={16} />
            </li>
            <li>
              {item?.isLast ? (
                <span className="breadcrumb-current" aria-current="page">
                  {item?.label}
                </span>
              ) : (
                <button
                  onClick={() => handleNavigation(item?.path)}
                  onKeyDown={(e) => handleKeyDown(e, item?.path)}
                  className="breadcrumb-item focus-ring rounded px-1"
                >
                  {item?.label}
                </button>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default NavigationBreadcrumb;